import GroupIcon from '@mui/icons-material/Group'
import GroupsIcon from '@mui/icons-material/Groups'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

function LandingPricing () {
  return (
    <section className='lp-pricing-section' id='pricing'>
      <div className='lp-section-content'>
        <h2 className='lp-section-title'>Transparente Preise</h2>
        <p className='lp-section-subtitle'>
          Faire Konditionen ohne versteckte Kosten
        </p>

        <div className='lp-pricing-grid'>
          <div className='lp-pricing-card'>
            <div className='lp-pricing-icon'>
              <GroupIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Kleine Teams</h3>
            <div className='lp-pricing-amount'>
              <span className='lp-price'>28€</span>
              <span className='lp-price-unit'>/User/Monat</span>
            </div>
            <p className='lp-pricing-description'>Unter 25 Benutzer</p>
            <ul className='lp-pricing-features'>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>Alle Features inklusive</span>
              </li>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>KI-gestützte Suche</span>
              </li>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>Unbegrenzte Wissensbeiträge</span>
              </li>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>Voller Support</span>
              </li>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>10% Rabatt bei Jahresvertrag</span>
              </li>
            </ul>
            <a href='#contact' className='lp-btn-pricing'>
              Demo anfragen
            </a>
          </div>

          <div className='lp-pricing-card lp-pricing-card-featured'>
            <div className='lp-pricing-badge'>Beliebt</div>
            <div className='lp-pricing-icon'>
              <GroupsIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Größere Teams</h3>
            <div className='lp-pricing-amount'>
              <span className='lp-price'>25€</span>
              <span className='lp-price-unit'>/User/Monat</span>
            </div>
            <p className='lp-pricing-description'>Ab 25 Benutzer</p>
            <ul className='lp-pricing-features'>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>Alle Features inklusive</span>
              </li>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>KI-gestützte Suche</span>
              </li>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>Unbegrenzte Wissensbeiträge</span>
              </li>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>Priority Support</span>
              </li>
              <li>
                <CheckCircleIcon sx={{ fontSize: 20 }} />
                <span>10% Rabatt bei Jahresvertrag</span>
              </li>
            </ul>
            <a href='#contact' className='lp-btn-pricing lp-btn-pricing-featured'>
              Demo anfragen
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingPricing

